import React from 'react'
import RootProtectedPages from './RootProtectedPages'

export * from './RootProtectedPages'
export default React.memo(RootProtectedPages)
